module.exports = __webpack_public_path__ + "408a12979c780ef5d7ef04a18189f86b.png";